<div class="navigation">
  <div class="navigation-inner">
    <a [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="'active'" class="nav-item" routerLink="">
      <img [style]="{ width: '40px' }" alt="train" src="../../../../assets/icons/intercity.svg" />
      Trein
    </a>
    <a [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="'active'" class="nav-item" routerLink="koffer">
      <img alt="Koffer" src="../../../../assets/icons/noun-suitcase.png" />
      Koffer
    </a>
    <a [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="'active'" class="nav-item" routerLink="help">
      <img alt="Help" src="../../../../assets/icons/question-mark.svg" />
      Help
    </a>
  </div>
</div>
